const CANONICAL_QUERY_PARAM_KEYS = ['tab', 'page', 'slug'] as const

export const buildCanonicalPath = (
  pathname: string,
  searchParams: URLSearchParams,
): string => {
  const canonicalParams = new URLSearchParams()

  for (const key of CANONICAL_QUERY_PARAM_KEYS) {
    const value = searchParams.get(key)
    if (value) {
      canonicalParams.set(key, value)
    }
  }

  const query = canonicalParams.toString()
  return query ? `${pathname}?${query}` : pathname
}
